import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { Drawer } from '@shared/abstraction/drawer/drawer';
import { DrawerBody } from '@shared/abstraction/drawer/drawer-body';
import { DrawerComponent } from '@shared/components/drawer/drawer.component';
import { UserEngagementDrawerData } from '../../models';

/**
 * Component for displaying user engagements in a drawer.
 * Implements the DrawerBody interface to be used within a DrawerComponent.
 */
@Component({
  standalone: false,
  selector: 'gstar-user-engagements-drawer',
  templateUrl: './user-engagements-drawer.component.html',
  styleUrl: './user-engagements-drawer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserEngagementsDrawerComponent implements DrawerBody, OnInit {
  @Input() setting!: Drawer;
  @Input() drawerPanel!: DrawerComponent;

  readonly data = signal<UserEngagementDrawerData | undefined>(undefined);

  ngOnInit(): void {
    this.data.set(this.setting.toBody<UserEngagementDrawerData>());
  }
}
